// extracted by mini-css-extract-plugin
export default {"switch-wrap":"card_switch-wrap__NwUP4","toggle-on-btn":"card_toggle-on-btn__kRF-g","toggle-off-btn":"card_toggle-off-btn__oFLAN","wrap":"card_wrap__i2WpQ","mask":"card_mask__Bx6lQ"};